/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { ReactElement, useEffect, useState } from "react"
import { MasterLayout } from "components/views/atoms/layouts/MasterLayout"
import TwoColumnRightPrimary from "components/views/atoms/layouts/TwoColumnRightPrimary"
import { GuidanceElement } from "../../lib/contentful/components/GuidanceElement"
import { talkToCarrotSource } from "../../components/talk-to-carrot/send-message/SendMessageUtil"
import { SendMessage } from "../../components/talk-to-carrot/send-message/SendMessage"
import Guidance from "../../components/views/atoms/Guidance"
import { TalkToCarrotLegal } from "../../components/talk-to-carrot/TalkToCarrotLegal"
import { getTalkToCarrotSendAMessagePageGuidance } from "lib/contentful/contentfulClient"
import BreadcrumbsHeader from "components/views/atoms/BreadcrumbsHeader"
import Breadcrumb from "components/views/atoms/Breadcrumb"
import { useCurrentUser } from "components/context/user/UserContext"
import { useHistory } from "react-router-dom"
import { Title } from "services/page-title/Title"
import { goToHelpCenterLegacy } from "carrot-api/HelpCenterClient"
import { useIntl } from "react-intl"

export function SendMessagePage(): JSX.Element {
  const [guidance, setGuidance] = useState<ReactElement<typeof Guidance>>(null)
  const { isInAppLockdown } = useCurrentUser()
  const history = useHistory()
  const intl = useIntl()
  const titleMessage = intl.formatMessage({
    defaultMessage: "Send a message"
  })
  const helpBreadcrumbTitle = intl.formatMessage({
    defaultMessage: "Help center"
  })
  const messageBreadcrumbTitle = intl.formatMessage({
    defaultMessage: "Send a message"
  })
  useEffect(() => {
    if (isInAppLockdown) {
      history.push("/get-help")
    }
  }, [history, isInAppLockdown])

  useEffect(() => {
    async function loadGuidance(): Promise<void> {
      const guidance = await getTalkToCarrotSendAMessagePageGuidance()
      setGuidance(<GuidanceElement guidance={guidance} />)
    }

    if (!guidance) {
      loadGuidance()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- See https://carrotfertility.atlassian.net/wiki/spaces/PE/pages/2050295461/Remove+Build+Warnings#react-hooks%2Fexhaustive-deps
  }, [])

  return (
    <>
      <Title title={titleMessage} />
      <MasterLayout
        header={
          <BreadcrumbsHeader
            breadcrumbs={[
              <Breadcrumb key="help-center" title={helpBreadcrumbTitle} onClick={() => goToHelpCenterLegacy()} />,
              <Breadcrumb
                key="send-a-message"
                title={messageBreadcrumbTitle}
                isActive
                onClick={() => {
                  /* Do nothing */
                }}
              />
            ]}
          />
        }
        footer={<TalkToCarrotLegal />}
      >
        <TwoColumnRightPrimary
          secondaryContent={guidance}
          primaryContent={<SendMessage source={talkToCarrotSource.SEND_A_MESSAGE_PAGE} />}
        />
      </MasterLayout>
    </>
  )
}
